import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { IonContent, IonFooter, IonHeader, IonPage } from '@ionic/vue';
import { ref } from 'vue';

import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import CustomFooter from "@/components/basePageElements/CustomFooter.vue";

import { BasePageProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePage',
  props: {
    header: { type: Boolean, default: true },
    sidebar: { type: Boolean, default: false },
    footer: { type: Boolean, default: false },
    noPadding: { type: Boolean },
    headerColor: {},
    backButton: { type: Boolean, default: true },
    fill: { type: Boolean },
    contentClass: { default: 'background-gradient-background' },
    fullscreen: { type: Boolean, default: true },
    emptyHeader: { type: Boolean },
    title: {},
    defaultHref: {},
    fixedRoute: {},
    forceBackground: { type: Boolean },
    collapse: { default: 'fade' },
    noCollapse: { type: Boolean },
    scrollY: { type: Boolean, default: true },
    scrollHeader: { type: Boolean, default: true },
    noAnimation: { type: Boolean },
    blocked: { type: Boolean },
    hasMenu: { type: Boolean },
    contentRelative: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const languageWatcher = ref<number>(0)

window.addEventListener('change-language', () => {
    languageWatcher.value++
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header-full", {}, () => [
        (props.header)
          ? (_openBlock(), _createBlock(_unref(IonHeader), {
              key: 0,
              class: _normalizeClass({ blocked: __props.blocked }),
              translucent: "",
              mode: "ios",
              collapse: (__props.emptyHeader || __props.noCollapse) ? undefined : __props.collapse
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _createVNode(CustomHeader, {
                    color: __props.headerColor,
                    "back-button": __props.backButton,
                    empty: __props.emptyHeader,
                    title: __props.title,
                    "default-href": __props.defaultHref,
                    "fixed-route": __props.fixedRoute,
                    "force-background": __props.forceBackground,
                    "no-animation": __props.noAnimation
                  }, {
                    start: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "header-start")
                    ]),
                    end: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "header-end")
                    ]),
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "header-content")
                    ]),
                    _: 3
                  }, 8, ["color", "back-button", "empty", "title", "default-href", "fixed-route", "force-background", "no-animation"])
                ])
              ]),
              _: 3
            }, 8, ["class", "collapse"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots['fixed'])
        ? (_openBlock(), _createElementBlock("div", {
            slot: "fixed",
            style: {"z-index":"1","max-height":"calc(100vh - var(--ion-safe-area-top) - var(--ion-safe-area-bottom) - 44px)"},
            class: _normalizeClass({ blocked: __props.blocked, 'overflow-auto': __props.scrollHeader }),
            key: languageWatcher.value
          }, [
            _renderSlot(_ctx.$slots, "fixed")
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_unref(IonContent), {
        fullscreen: __props.fullscreen,
        class: _normalizeClass(__props.contentClass),
        "scroll-y": __props.scrollY,
        key: languageWatcher.value
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["fullscreen", "class", "scroll-y"])),
      (props.footer)
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: languageWatcher.value }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createVNode(CustomFooter, { toolbar: "" })
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})